import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Forecast',
  props: {
    impactSolution: null,
    hideHeading: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var ghgSavingPotential = computed(function () {
      var _props$impactSolution;
      return (_props$impactSolution = props.impactSolution) === null || _props$impactSolution === void 0 ? void 0 : _props$impactSolution.ghgSavingPotential;
    });
    var growthFactorMetricAssignment = computed(function () {
      var _props$impactSolution2, _props$impactSolution3;
      return (_props$impactSolution2 = props.impactSolution) === null || _props$impactSolution2 === void 0 ? void 0 : (_props$impactSolution3 = _props$impactSolution2.ghgSavingPotential) === null || _props$impactSolution3 === void 0 ? void 0 : _props$impactSolution3.metricAssignments.find(function (e) {
        var _e$metric;
        return ((_e$metric = e.metric) === null || _e$metric === void 0 ? void 0 : _e$metric.id) === 1216;
      });
    });
    var growthFactorComment = computed(function () {
      var ma = growthFactorMetricAssignment.value;
      return ma && ma.comment ? ma.comment : '';
    });
    var recurrentGhgReductionsText = computed(function () {
      var ghg = ghgSavingPotential.value;
      if (ghg !== null && ghg !== void 0 && ghg.isRecurringImpact && ghg.durationOfImpact != null) {
        return String(proxy.$t('recurrentGhgReductions', {
          duration: ghg.durationOfImpact
        }));
      }
      return null;
    });
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      ghgSavingPotential: ghgSavingPotential,
      growthFactorMetricAssignment: growthFactorMetricAssignment,
      growthFactorComment: growthFactorComment,
      recurrentGhgReductionsText: recurrentGhgReductionsText
    };
  }
});